import React from "react";

import ReusableModal from "components/Modals/ReusableModal";


const DeleteQuestion = ({
    isOpen,
    onClose,
    onConfirm,
    question,
}) => {

    const bodyMessage = `
        Are you sure you want to delete this question?
        <br />
        <strong>${question || ""}</strong>
        <br />
        This action cannot be undone.
    `;


    return (

        <ReusableModal

            isOpen={isOpen}

            onClose={onClose}

            onConfirm={onConfirm}

            title="Confirm Delete"

            bodyMessage={
                <div
                    dangerouslySetInnerHTML={{
                        __html:
                            bodyMessage,
                    }}
                />
            }

            confirmLabel="Confirm"

            cancelLabel="Cancel"
        />
    );
};


export default DeleteQuestion;